import getters from './getters';
import mutations, { MUTATIONS } from './mutations';
import createActions, { ACTIONS } from './actions';

const createModule = function (params) {
  const moduleStore = {
    namespaced: true,
    state: {
      loading: false,
      profileLoaded: false,
      profile: null,
      nube: false,
      after_register: false,
    },
    getters,
    mutations,
    actions: createActions(params),
  };
  return moduleStore;
};

export { ACTIONS, MUTATIONS };

export default createModule;



// WEBPACK FOOTER //
// ./src/store/user/index.js